<template>
	<div class="home">
		<div class="hero">
			<el-skeleton :loading="bannerLoading" animated>
				<template slot="template">
					<el-skeleton-item variant="image" style="width: 100%; height: 400px;" />
				</template>
			</el-skeleton>
			<div ref="carousel" v-if="!bannerLoading">
				<el-carousel ref="carouselRef" @change="handleCarouselChange" style="width: 100%;" height="400px"
					:autoplay="true" :interval="5000">
					<el-carousel-item v-for="(item, index) in sliderItems" :key="index">
						<div class="carousel-item">
							<img :src="item.imageUrl" :alt="item.title" class="carousel-image">
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>

			<!-- 查询区域 -->
			<div class="search-container" :class="{ 'search-container-fixed': isSearchFixed }">
				<div class="search-wrapper">
					<div class="custom-search-input">
						<el-input type="text" :placeholder="$t('searchPlaceholder')" v-model="searchKeyword"
							class="search-input" />
						<button class="search-button" @click="searchByKeyword">{{ $t('search') }}</button>
					</div>

					<div class="upload-button">
						<button class="image-search-button" @click="triggerFileInput">
							<i class="el-icon-upload" style="font-size: 24px;"></i>
							<span>{{$t('searchByImage')}}</span>
						</button>
						<input type="file" ref="fileInput" class="file-input" accept="image/*" multiple
							@change="handleFileUpload" title="">
					</div>

				</div>
			</div>
		</div>

		<!-- 代购平台 -->
		<div class="platform-section" :style="{'padding':platforms.length>8?'50px 0 0 0': '50px 0 20px 0'}">
			<div class="container">
				<div class="section-header">
					<div class="section-divider"></div>
					<h3>{{ $t('selectPlatforms') }}</h3>
				</div>
				<el-carousel :interval="0" height="240px" indicator-position="outside" v-if="platforms.length > 8">
					<el-carousel-item v-for="(page, pageIndex) in Math.ceil(platforms.length / 8)" :key="pageIndex">
						<div class="platform-list">
							<div class="platform-row" v-for="(row, rowIndex) in 2" :key="rowIndex">
								<div class="platform-item"
									v-for="(platform, index) in platforms.slice(pageIndex * 8 + rowIndex * 4, pageIndex * 8 + rowIndex * 4 + 4)"
									:key="platform.id" @click="search(platform)">
									<div class="platform-image-container">
										<img :src="platform.platformIcon" :alt="platform.platformName"
											class="platform-image">
									</div>
									<span class="platform-name">{{ platform.platformName }}</span>
									<span class="platform-go">GO！</span>
								</div>
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
				<div class="platform-list" v-else>
					<div class="platform-row" v-for="(row, rowIndex) in 2" :key="rowIndex">
						<div class="platform-item"
							v-for="(platform, index) in platforms.slice(rowIndex * 4, rowIndex * 4 + 4)"
							:key="platform.id" @click="search(platform)">
							<div class="platform-image-container">
								<img :src="platform.platformIcon" :alt="platform.platformName" class="platform-image">
							</div>
							<span class="platform-name">{{ platform.platformName }}</span>
							<span class="platform-go">GO！</span>
						</div>
					</div>
				</div>
				<el-skeleton :loading="platformLoading" animated :rows="3"> </el-skeleton>
			</div>
		</div>

		<!-- 热销商品 -->
		<div class="best-sellers-section">
			<div class="container">
				<div class="section-header" ref="headerFilters">
					<div class="section-divider"></div>
					<h3>{{ $t('bestSellers') }}</h3>
				</div>
				<div :class="{ 'show-mask': enquiryDialogVisible||complaintDialogVisible }">
					<!-- 商品分类 -->
					<CategoryTree ref="categoryTree" :is-category-fixed="isCategoryFixed"
						@category-selected="handleCategorySelected" />
				</div>
				<div :style="{marginTop:isSearchFixed&&isCategoryFixed?'140px':'0'}">
					<!-- 商品列表 -->
					<ProductListForRecommend ref="recommendProductList" :category-id="selectCategoryId" />
				</div>
			</div>
		</div>

		<!-- 查看更多 -->
		<div class="view-more-banner" @click="search">
			<div class="banner-container">
				<img src="/icon/home/view_more_products.png" :alt="$t('viewMoreProducts')" class="banner-image">
				<span class="banner-text">{{ $t('viewMoreProducts') }}</span>
			</div>
		</div>

		<!-- 平台介绍 -->
		<div class="how-it-works-section">
			<div class="container">
				<div class="steps-container">
					<div class="step-item">
						<div class="step-image">
							<img src="/icon/home/tip1.png" alt="Step 1">
						</div>
						<h2>{{ $t('buyChineseProductsEasy') }}</h2>
						<p>{{ $t('buyChineseProductsDesc') }}</p>
					</div>
					<div class="step-item">
						<div class="step-image">
							<img src="/icon/home/tip2.png" alt="Step 2">
						</div>
						<h2>{{ $t('selectFavoritePlatform') }}</h2>
						<p>{{ $t('platformListDesc') }}</p>
					</div>
					<div class="step-item">
						<div class="step-image">
							<img src="/icon/home/tip3.png" alt="Step 3">
						</div>
						<h2>{{ $t('goodsDelivered') }}</h2>
						<p>{{ $t('afterPurchaseDesc') }}</p>
					</div>
				</div>
			</div>
		</div>

		<RightFixedPanel @openEnquiry="enquiryDialogVisible = true" @openComplaint="complaintDialogVisible = true" />

		<EnquiryDialog :visible.sync="enquiryDialogVisible" />

		<ComplaintDialog :visible.sync="complaintDialogVisible" />

	</div>
</template>

<script>
	import homeApi from '@/api/home'
	import RightFixedPanel from '@/components/RightFixedPanel.vue';
	import EnquiryDialog from '@/components/EnquiryDialog.vue';
	import ComplaintDialog from '@/components/ComplaintDialog.vue'
	import ProductListForRecommend from '@/components/ProductListForRecommend.vue';
	import CategoryTree from '@/components/CategoryTree.vue';
	export default {
		name: 'Home',
		components: {
			RightFixedPanel,
			EnquiryDialog,
			ComplaintDialog,
			ProductListForRecommend,
			CategoryTree
		},
		data() {
			return {
				bannerLoading: true,
				platformLoading: true, //是否显示代购平台骨架
				enquiryDialogVisible: false,
				complaintDialogVisible: false,
				searchKeyword: '',
				isSearchFixed: false,
				isCategoryFixed: false,
				sliderItems: [], //轮播图
				platforms: [], //代购平台
				selectCategoryId: null, //选中的商品分类ID
				currentIndex: 0, //当前轮播图索引

			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
			this.$once('hook:destroyed', () => {
				window.removeEventListener('scroll', this.handleScroll)
			})
			this.$nextTick(() => {
				//加载商品分类
				if (this.$refs.categoryTree && typeof this.$refs.categoryTree.init === 'function') {
					this.$refs.categoryTree.init();
				}
				this.loadGoods();
			});
		},
		created() {
			this.getBanner();
			this.getPlatform();
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
			this.$once('hook:destroyed', () => {
				window.removeEventListener('scroll', this.handleScroll)
			})
			this.$nextTick(() => {
				//加载商品分类
				if (this.$refs.categoryTree && typeof this.$refs.categoryTree.init === 'function') {
					this.$refs.categoryTree.init();
				}
				this.loadGoods();
			});
		},
		methods: {
			// 触发文件选择
			triggerFileInput() {
				this.$refs.fileInput.click();
			},
			// 处理文件上传
			handleFileUpload(event) {
				const files = event.target.files;
				if (files.length > 0) {
					// 处理文件并存储到sessionStorage
					const fileDataArray = [];

					// 处理每个文件
					for (let i = 0; i < files.length; i++) {
						const file = files[i];
						// 创建文件URL用于预览
						const imageUrl = URL.createObjectURL(file);

						// 创建文件数据对象
						const fileData = {
							url: imageUrl,
							name: file.name,
							size: file.size,
							type: file.type
						};

						fileDataArray.push(fileData);
					}

					// 存储文件数据到sessionStorage
					sessionStorage.setItem('uploadedFiles', JSON.stringify(fileDataArray));

					// 跳转到产品搜索页面
					if (files.length <= 6) {
						this.$router.push({
							path: '/product-search-image'
						});
					} else {
						this.$router.push({
							path: '/product-search-more-image'
						});
					}

				}
			},
			//加载商品列表
			loadGoods() {
				if (this.$refs.recommendProductList && typeof this.$refs.recommendProductList.init === 'function') {
					this.$refs.recommendProductList.init();
				}
			},
			//获取代购平台
			async getPlatform() {
				const res = await homeApi.getPlatform();
				this.platforms = res.result;
				this.platformLoading = false;
			},
			//获取轮播图
			async getBanner() {
				const res = await homeApi.getBanner('HOME');
				this.sliderItems = res.result;
				this.bannerLoading = false;
			},
			handleScroll() {
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				const carouselOffset = this.$refs.carousel ? this.$refs.carousel.offsetTop : 0
				const headerOffset = this.$refs.headerFilters ? this.$refs.headerFilters.offsetTop : 0
				this.isSearchFixed = carouselOffset - scrollTop < -400
				this.isCategoryFixed = headerOffset - scrollTop < 30
			},
			search(platform) {
				// 跳转到产品搜索页面
				this.$router.push({
					path: '/product',
					query: {
						keyword: this.searchKeyword.trim(),
						platformId: platform ? platform.id : ''
					}
				})
			},
			searchByKeyword(){
				if(!this.searchKeyword) {
					return;
				}
				this.search();
			},
			// 处理分类选择
			handleCategorySelected(category) {
				this.selectCategoryId = category.id;
				console.log(this.selectCategoryId);
				setTimeout(() => {
					this.loadGoods();
				}, 200)
			},

			// 处理轮播图切换事件
			handleCarouselChange(index) {
				this.currentIndex = index;
			},
			// 处理指示器点击事件
			handleIndicatorClick(index) {
				this.currentIndex = index;
				if (this.$refs.carouselRef) {
					this.$refs.carouselRef.setActiveItem(index);
				}
			}
		}
	}
</script>

<style scoped>
	.home {
		width: 100%;
		min-height: calc(100vh - 60px);
	}

	.hero {
		position: relative;
		width: 100%;
	}

	.el-carousel__container {
		height: 450px !important;
	}

	.carousel-item {
		width: 100%;
		position: relative;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.carousel-content {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		align-items: center;
		padding: 0 50px;
		color: white;
		background-color: rgba(0, 0, 0, 0.3);
	}

	.carousel-text {
		max-width: 600px;
	}

	.carousel-text .highlight {
		display: inline-block;
		background-color: rgba(255, 255, 255, 0.2);
		padding: 5px 10px;
		border-radius: 3px;
		font-size: 14px;
		margin-bottom: 10px;
	}

	.carousel-image {
		width: 100%;
		height: auto;
		display: block;
		object-fit: cover;
		object-position: center;
	}

	:deep .el-carousel__indicators--horizontal {
		bottom: 100px;
	}

	:deep .el-carousel__button {
		width: 15px;
		height: 15px;
		border-radius: 100px;
	}

	:deep .is-active button {
		width: 40px;
	}

	:deep .is-active button {
		background-color: #016AF8;
	}

	.search-container {
		position: absolute;
		bottom: 0px;
		left: 0;
		right: 0;
		display: flex;
		justify-content: center;
		z-index: 10;
	}

	.search-container.search-container-fixed {
		position: fixed !important;
		top: 0px !important;
		left: 0 !important;
		right: 0 !important;
		bottom: auto !important;
		z-index: 1000 !important;
	}

	.search-container.search-container-fixed .search-wrapper {
		background-color: white !important;
		padding: 10px;
	}

	.search-container.search-container-fixed .custom-search-input {
		width: 64%;
		border-color: #F59A23;
		background-color: rgba(0, 0, 0, 0.05);
	}

	.search-container.search-container-fixed .search-button {
		height: 35px;
		width: 100px;
		font-size: 14px;
	}

	.search-container.search-container-fixed .image-search-button {
		height: 40px;
		padding: 0 15px;
		font-size: 14px;
	}

	.search-container.search-container-fixed :deep .el-input__inner {
		color: #333;
		height: 35px;
	}

	.search-wrapper {
		background-color: rgba(255, 255, 255, 0.35);
		padding: 20px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		gap: 10px;
	}

	.custom-search-input {
		display: flex;
		align-items: center;
		border-radius: 10px;
		width: 60%;
		overflow: hidden;
		background-color: rgba(0, 0, 0, 0.35);
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		border: 2px solid #F59A23;
	}

	.search-button {
		background-color: #F59A23;
		color: white;
		border: none;
		height: 60px;
		width: 160px;
		cursor: pointer;
		font-size: 17px;
		transition: background-color 0.3s;
	}

	:deep .el-input__inner {
		background-color: transparent !important;
		border: 0 solid #DCDFE6;
		font-size: 16px;
		color: #fff;
	}

	.search-button:hover {
		background-color: #F59A23;
	}

	.image-search-button {
		background-color: #D9001B;
		color: white;
		border: none;
		height: 65px;
		padding: 0 20px;
		cursor: pointer;
		font-size: 16px;
		display: flex;
		align-items: center;
		gap: 5px;
		border-radius: 10px;
		transition: background-color 0.3s;
		font-weight: bold;
	}

	.image-search-button:hover {
		background-color: #D9001B;
	}

	.platform-section {
		padding: 50px 0 0 0;
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 20px;
	}

	.platform-section h3 {
		font-size: 20px;
		font-weight: 600;
		color: #333;
		margin: 0;
	}

	.platform-list {
		display: flex;
		flex-direction: column;
		gap: 20px;
		padding: 20px 0;
		width: 100%;
	}

	.platform-row {
		display: flex;
		gap: 20px;
		justify-content: flex-start;
	}

	.platform-item {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 15px 20px;
		background-color: #E6F1FE;
		border-radius: 8px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		width: calc(25% - 15px);
		height: 90px;
		gap: 15px;
		position: relative;
		justify-content: space-between;
		overflow: hidden;
		z-index: 1;
		cursor: pointer;
	}

	.el-carousel__item {
		width: 100%;
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 20px;
	}

	.el-carousel__indicators {
		bottom: -20px;
	}

	.el-carousel__button {
		width: 12px;
		height: 12px;
		border-radius: 6px;
		background-color: #D9D9D9;
		transition: all 0.3s ease;
	}

	.el-carousel__button.is-active {
		width: 24px;
		background-color: #016AF8;
	}

	.platform-item::before {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 0;
		background-color: #016AF8;
		transition: height 0.1s ease-out;
		z-index: -1;
	}

	.platform-item:hover::before {
		height: 100%;
	}

	.platform-name {
		font-size: 16px;
		color: #333;
		font-weight: 500;
	}

	.platform-go {
		font-size: 20px !important;
		color: #333;
		font-weight: bold;
		opacity: 0;
	}

	.platform-item:hover .platform-name {
		color: white;
	}

	.platform-item:hover .platform-go {
		opacity: 1;
		color: white;
	}

	.platform-item:hover .platform-image-container {
		display: none;
	}

	.platform-image-container {
		min-width: 60px;
		min-height: 60px;
		position: relative;
		overflow: hidden;
	}

	.platform-image,
	.platform-hover-image {
		width: 100%;
		height: 100%;
		position: absolute;
		border-radius: 8px;
	}

	.platform-item span {
		font-size: 17px;
		color: #333;
		font-weight: bold;
	}

	/* View More Products Banner */
	.view-more-banner {
		background-color: #fff;
		padding: 30px 0;
		cursor: pointer;
	}

	.banner-image {
		width: 100%;
		height: auto;
		border-radius: 8px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	}

	/* How It Works Section */
	.how-it-works-section {
		background-color: #fff;
		padding: 50px 0;
	}

	.steps-container {
		display: flex;
		gap: 40px;
		justify-content: space-between;
		margin-top: 30px;
	}

	.step-item {
		flex: 1;
		text-align: center;
		padding: 0 15px;
	}

	.step-image {
		margin-bottom: 20px;
	}

	.step-image img {
		width: 140px;
		height: 140px;
		object-fit: contain;
	}

	.step-item h2 {
		font-size: 22px;
		margin-bottom: 5px;
		font-weight: bold;
		text-align: left;
	}

	.step-item p {
		text-align: left;
		font-size: 15px;
		color: #666;
		line-height: 1.7;
		margin: 0;
	}

	/* View More Products Banner */
	.view-more-banner {
		padding: 20px 0;
	}

	.banner-container {
		position: relative;
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 20px;
	}

	.banner-image {
		width: 100%;
		height: auto;
		display: block;
		border-radius: 8px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	}

	.banner-text {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: white;
		font-size: 20px;
		font-weight: bold;
		text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
		white-space: nowrap;
	}

	.upload-button {
		position: relative;
	}

	.file-input {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		cursor: pointer;
		z-index: 1;
	}
</style>